import { getLocale } from '~/paraglide/runtime.js'

const EURO_INPUT = /^\d{1,7}([.,]\d{1,2})?$/

export function formatCents(cents: number, locale: string = getLocale()): string {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(cents / 100)
}

/** Euros as typed ("12", "12,5", "12.50 €") in cents; empty means 0, anything unreadable null. */
export function parseEuros(text: string): number | null {
  const cleaned = text.replace(/[\s€]/g, '')
  if (cleaned === '') return 0
  if (!EURO_INPUT.test(cleaned)) return null
  return Math.round(Number(cleaned.replace(',', '.')) * 100)
}

export function centsToInput(cents: number, locale: string = getLocale()): string {
  if (cents === 0) return ''
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
  }).format(cents / 100)
}
